import {camelToSentence} from 'App/utils/string';

type Option = {
  label: string;
  value: string;
};

export const createOptionsFromSDK = (obj: Record<string, string>): Option[] => {
  return Object.entries(obj).map(([key, value]) => ({
    label: camelToSentence(key, true),
    value
  }));
};
